import { Config } from "../../../configurations/config";
export const ReviewedLeaveApplication_API = {
  GetLeaveTypes: `${Config.server_url}${Config.api_prefix}/Leave/LeaveTypes`,
  GetReviewedLeaves_API: `${Config.server_url}${Config.api_prefix}/Leave/ReviewedLeaveApplications?`,
  ExportToExcel: `${Config.server_url}${Config.api_prefix}/Leave/ReviewedLeaveApplications/ExportToExcel`,
  GetReviewedLeaveById: `${Config.server_url}${Config.api_prefix}/Leave/ReviewedLeaveApplications`,
  GetSupervisorsEmployeesList: `${Config.server_url}${Config.api_prefix}/Employee/GetSupervisorsEmployeesList`,
  GetAdminEmployeesList: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployees?AllEmployees=true`,
};
